export const STATUSES = Object.freeze({
  INVALID: 'invalid',
  NOT_FOUND: 'not found',
  NOT_CHECKED: 'not checked',
  ACCEPT_ALL: 'accept_all',
  VALID: 'valid',
  PROCESSING: 'processing',
});
